;
// Carousel functionality
(() => {
  const r = document.querySelector("#customer-videos");
  if (!r) return;

  const o = r.querySelector(".cv-row"),
        p = r.querySelector(".cv-prev"),
        n = r.querySelector(".cv-next"),
        d = [...r.querySelectorAll(".cv-dot")],
        c = [...r.querySelectorAll(".cv-card")],
        m = () => matchMedia("(max-width: 999px)").matches,
        i = () => {
          const t = o.getBoundingClientRect(),
                e = t.left + t.width / 2;
          let s = 0, l = 1 / 0;
          c.forEach((a, f) => {
            const g = a.getBoundingClientRect(),
                  h = g.left + g.width / 2,
                  u = Math.abs(h - e);
            u < l && (l = u, s = f)
          });
          return s
        },
        s = t => {
          c[t] && c[t].scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
            block: "nearest"
          });
          requestAnimationFrame(u)
        },
        a = e => {
          if (!m()) return;
          const t = i(),
                l = Math.min(c.length - 1, Math.max(0, t + e));
          if (l === t) return;
          s(l)
        },
        u = () => {
          if (!m()) return;
          const t = i();
          d.forEach((e, l) => e.classList.toggle("is-active", l === t));
          if (p) {
            const e = t <= 0;
            p.disabled = e;
            p.setAttribute("aria-disabled", "" + e)
          }
          if (n) {
            const e = t >= c.length - 1;
            n.disabled = e;
            n.setAttribute("aria-disabled", "" + e)
          }
        };

  p?.addEventListener("click", () => a(-1));
  n?.addEventListener("click", () => a(1));
  o?.addEventListener("scroll", () => {
    requestAnimationFrame(u)
  });
  addEventListener("resize", u);
  d.forEach((t, e) => t.addEventListener("click", () => {
    m() && s(e)
  }));
  u();
})();

// Video lazy loading and autoplay on click
(() => {
  const placeholders = document.querySelectorAll('.video-placeholder');
  if (!placeholders.length) return;

  placeholders.forEach(placeholder => {
    placeholder.addEventListener('click', function(e) {
      // Prevent multiple clicks
      if (this.classList.contains('video-loaded')) return;

      const videoSrc = this.getAttribute('data-src');

      // Create video element
      const video = document.createElement('video');
      video.className = 'cv-video';
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true; // autoplay on click
      video.muted = false; // change to true if autoplay requires muted
      video.preload = 'metadata';

      const source = document.createElement('source');
      source.src = videoSrc;
      source.type = 'video/mp4';
      video.appendChild(source);

      // Hide placeholder image and play button
      const img = this.querySelector('.placeholder-image');
      if (img) img.style.display = 'none';

      const playBtn = this.querySelector('.play-button');
      if (playBtn) playBtn.style.display = 'none';

      // Append video inside placeholder
      this.appendChild(video);
      this.classList.add('video-loaded');

      // Play the video
      video.play().catch(err => {
        console.log('Autoplay blocked:', err);
      });
    });
  });
})();


;
/* Single-open behavior: opening one details closes the others */
(function(){
  var faq = document.getElementById('faq-objections');
  if(!faq) return;
  var items = faq.querySelectorAll('.faq-item');
  items.forEach(function(el){
    el.addEventListener('toggle', function(){
      if (el.open) {
        items.forEach(function(other){
          if (other !== el) other.removeAttribute('open');
        });
      }
    });
  });
})();

;
(function(){
  function init(){
    var slider=document.querySelector('.thumbnail-slider'), list=document.querySelector('.thumbnail-list');
    if(!slider||!list||slider.querySelector('.ff-more')) return;
    function img(){ return document.querySelector('.product__media-item.is-active .product__media')||document.querySelector('.product__media'); }
    var badge=document.createElement('div'); badge.className='ff-more'; badge.setAttribute('hidden','');
    badge.appendChild(document.createElement('span'));
    slider.appendChild(badge);
    var off=0, cap=0;
    function desktop(){ return window.matchMedia && matchMedia('(min-width:990px)').matches; }
    function items(){ return Array.prototype.filter.call(list.querySelectorAll('.thumbnail-list__item'), function(t){ return t.getBoundingClientRect().height>0; }); }
    function maxoff(){ return Math.max(0, list.scrollHeight - cap); }
    function sync(){
      if(!desktop()||cap<=0){ badge.setAttribute('hidden',''); return; }
      var winB=off+cap, h=0;
      items().forEach(function(t){ if(t.offsetTop + t.offsetHeight > winB + 2) h++; });
      if(h>0){ badge.firstChild.textContent='+'+h; badge.removeAttribute('hidden'); } else badge.setAttribute('hidden','');
    }
    function apply(){ list.style.setProperty('--ff-off', off+'px'); sync(); }
    function setCap(){
      var m=img(); if(!m) return;
      if(!desktop()){ slider.style.removeProperty('--ff-cap'); off=0; list.style.setProperty('--ff-off','0px'); badge.setAttribute('hidden',''); return; }
      cap=Math.round(m.getBoundingClientRect().height); slider.style.setProperty('--ff-cap', cap+'px');
      off=Math.min(off, maxoff()); apply();
    }
    badge.addEventListener('click', function(){ var mo=maxoff(); off=(off>=mo-1)?0:Math.min(mo, off+Math.round(cap*0.85)); apply(); });
    slider.addEventListener('wheel', function(e){ var mo=maxoff(); if(!desktop()||mo<=0) return; var nx=Math.min(mo, Math.max(0, off+e.deltaY)); if(nx!==off){ e.preventDefault(); off=nx; apply(); } }, {passive:false});
    var mi=img()&&img().querySelector('img'); if(mi){ if(mi.complete) setCap(); mi.addEventListener('load', setCap); }
    setCap();
    [150,450,1000].forEach(function(t){ setTimeout(setCap,t); });
    var tm; window.addEventListener('resize', function(){ clearTimeout(tm); tm=setTimeout(setCap,150); });
    document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.thumbnail-list__item')){ setTimeout(setCap,120); } }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
